import { Banner } from "@newsela/angelou";

export interface EmptyStateBannerProps {
  emptyStateMessage: string;
  emptyStateButtonText?: string;
  emptyStateButtonHref?: string;
  bannerHasCta: boolean;
}

const EmptyStateBanner = (props: EmptyStateBannerProps) => {
  const {
    emptyStateMessage,
    emptyStateButtonText,
    emptyStateButtonHref,
    bannerHasCta,
  } = props;

  const ctaPropsObj = bannerHasCta
    ? {
        ctaProps: {
          text: emptyStateButtonText ?? "",
          href: emptyStateButtonHref ?? "",
          openInNewTab: false,
        },
      }
    : {};

  return (
    <Banner
      rootElement="div"
      bannerType={Banner.types.info}
      body={emptyStateMessage}
      {...ctaPropsObj}
    />
  );
};

export default EmptyStateBanner;
